import { render } from "./NumberPlayer.vue?vue&type=template&id=22a2123e"
import script from "./NumberPlayer.vue?vue&type=script&lang=ts"
export * from "./NumberPlayer.vue?vue&type=script&lang=ts"
script.render = render

export default script